import { alpha, Palette } from '@mui/material';

// The same bar as the candidate search table (table-v3.css), so both tables
// look alike. Styling a WebKit scrollbar keeps it on screen, where macOS would
// hide it until a scroll; once styled, the thumb must be painted too.
export const getVisibleScrollbarStyles = (palette: Palette) => {
  const thumbColour = alpha(palette.common.black, 0.5);

  return {
    '&::-webkit-scrollbar': {
      WebkitAppearance: 'none',
      height: '8px'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: thumbColour,
      borderRadius: '4px'
    },
    // Gated, or Chrome 121+ prefers these and goes back to a hidden bar.
    '@supports not selector(::-webkit-scrollbar)': {
      scrollbarWidth: 'auto',
      scrollbarColor: `${thumbColour} transparent`
    }
  };
};
